import axiosClient from './axiosClient';

export default {
  getFascicoloById: (id) => axiosClient.get(`/fascicolo/${id}`),
  getFascicoloByContribuenteId: (id) => axiosClient.get(`/fascicolo/contribuente/${id}`),
  getMyFascicolo: () => axiosClient.get('/fascicolo/me'),
  getDocumenti: (fascicoloId) => axiosClient.get(`/fascicolo/${fascicoloId}/documenti/fascicolo`),
  uploadDocumento: (fascicoloId, formData) =>
    axiosClient.post(`/fascicolo/${fascicoloId}/documenti/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  downloadDocumento: (documentoId) =>
    axiosClient.get(`/fascicolo/documenti/${documentoId}/download`, { responseType: 'blob' }),
  deleteDocumento: (documentoId) => axiosClient.delete(`/fascicolo/documenti/${documentoId}`),
  updateDocumento: (documentoId, data) => axiosClient.put(`/fascicolo/documenti/${documentoId}`, data),
  createrequest: (data) => axiosClient.post(`/fascicolo/richieste/create`, data),
  createDocumentoDaRichiesta: (richiestaId, data) => axiosClient.put(`/fascicolo/richieste/{richiestaId}/documento`, data),
  getRichiesteNonEvase: (fascicoloId) => axiosClient.get(`/fascicolo/${fascicoloId}/richiestenonevase`),
  getDocumentiFascicolo: (fascicoloId) => axiosClient.get(`/fascicolo/${fascicoloId}/documenti/fascicolo`),
  getDocumentiFascicoloPaginated: (fascicoloId, params) =>
   axiosClient.get(`/fascicolo/${fascicoloId}/documentipag/fascicolo`, { params }),
  changeStatoRichiesta: (richiestaId, stato) =>
  axiosClient.put(
    `/fascicolo/richieste/${richiestaId}/stato`,
    null,
    {
      params: { stato }
    }
  )
};